import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3ebd5329"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebd5329')) {
      api.createRecord('3ebd5329', component.options)
    } else {
      api.reload('3ebd5329', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=3ebd5329", function () {
      api.rerender('3ebd5329', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/teach/home.vue"
export default component.exports